<script lang="ts">
  import { type Snippet } from 'svelte'
  import { Canvas } from '@threlte/core'
  import Scene from './Scene.svelte'
  import i18n from '../../i18n'
  import { logoDarkFull, logoLightFull } from '../../assets/images'
  import Footer from '../footer/Footer.svelte'

  type Props = {
    children?: Snippet
    title: string
  }

  let { children, title }: Props = $props()
</script>

<div class="auth">
  <div class="form">
    <div class="head">
      <img
        class="dark-hidden"
        alt={$i18n.t('authLayout.logoAlt')}
        src={logoLightFull}
      />
      <img
        class="light-hidden"
        alt={$i18n.t('authLayout.logoAlt')}
        src={logoDarkFull}
      />
      <h1>{title}</h1>
    </div>
    {@render children?.()}
  </div>
  <div class="scene">
    <Canvas>
      <Scene />
    </Canvas>
  </div>
</div>

<Footer />

<style lang="scss">
  .auth {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    min-height: 100vh;

    .form {
      padding: 0 1.5rem;
      grid-column: 1/6;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 1.5rem;

      .head {
        display: flex;
        align-items: center;
        flex-direction: column;
        gap: 1rem;
        width: 100%;

        img {
          max-width: 12rem;
        }

        h1 {
          font-weight: 500;
        }
      }
    }

    .scene {
      grid-column: 6/13;
    }

    .form,
    .scene {
      min-height: 100%;
    }
  }

  @media only screen and (max-width: 1224px) {
    .auth {
      display: flex;

      .form {
        width: 100%;
      }

      .scene {
        display: none;
      }
    }
  }
</style>
